import { createSlice } from "@reduxjs/toolkit";
import _ from 'lodash';

const initialPatientState = {
  error: null,
  listLoading: false,
  actionsLoading: false,
  selectedPatient: null,
  problems: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const patientsSlice = createSlice({
  name: "patients",
  initialState: initialPatientState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    patientProblemsFetched: (state, action) => {
      const { problems, patientId } = action.payload;
      state.error = null;
      state.listLoading = false;
      let data = { ...state.problems };
      data[`${patientId}`] = problems;
      state.problems = data;

    },
    updateProblem: (state, action) => {

      const { problem, patientId } = action.payload;
      let data = _.cloneDeep(state.problems);
      data[`${patientId}`] = problem.all;
      state.problems =  data;
      state.error = null;
      state.listLoading = false;
    },
    upsertProblem: (state, action) => {      
      const { problem, patientId } = action.payload;

      let data = _.cloneDeep(state.problems);

      let updateIndex = [...data[`${patientId}`]].findIndex(
        (item) => item.id === problem.id
      );

       let problemsDumb =  data[`${patientId}`];

      if (updateIndex !== -1) {
        problemsDumb[updateIndex] = problem;
      } else {
        problemsDumb.push(problem);
      }

      data[`${patientId}`] = problemsDumb;

      state.problems =  data;
      state.error = null;
      state.listLoading = false;
      
    },

    addProblem: (state, action) => { 
      const { problem, patientId } = action.payload;
      let data = _.cloneDeep(state.problems);

      data[patientId] = problem.all;
      state.problems = data;
      state.error = null;
      state.listLoading = false;
    }
  },
});
